<template>
  <section v-if="isAdmin" class="ine-form">
    <Background />
    <ManageImpersonationForm
      v-if="currentMode === 'impersonate-user'"
      :isImpersonating="isImpersonating"
      :profile="profile"
    />
    <ManageSuspensionForm v-if="currentMode === 'manage-user-suspension'" />
    <ManagePasswordForm
      v-if="currentMode === 'manage-user-password'"
      :newPassword="newPassword"
    />
    <ManageConfirmationForm v-if="currentMode === 'manage-user-confirmation'" />
  </section>
</template>

<script>
import { mapState } from 'vuex'
import Background from '@/components/forms/elements/Background.vue'
import ManageConfirmationForm from '@/components/forms/admin/ManageConfirmationForm.vue'
import ManageImpersonationForm from '@/components/forms/admin/ManageImpersonationForm.vue'
import ManagePasswordForm from '@/components/forms/admin/ManagePasswordForm.vue'
import ManageSuspensionForm from '@/components/forms/admin/ManageSuspensionForm.vue'

export default {
  name: 'Admin',
  components: {
    Background,
    ManageConfirmationForm,
    ManageImpersonationForm,
    ManagePasswordForm,
    ManageSuspensionForm,
  },
  metaInfo() {
    return {
      title: 'INE - Admin',
      meta: [
        {
          vmid: 'robots',
          name: 'robots',
          content: 'noindex',
        },
      ],
    }
  },
  data() {
    return {
      currentEmailValid: false,
      passwordValid: false,
    }
  },
  computed: {
    ...mapState({
      isAdmin: state => state.auth.isAdmin,
      isImpersonating: state => state.admin.isImpersonating,
      profile: state => state.auth.userProfile,
      newPassword: state => state.admin.usersNewPassword,
    }),
    currentMode() {
      return this.$route.params.mode
    },
  },
  created() {
    if (!this.isAdmin) {
      this.$router.push({ name: 'home' })
    }
  },
}
</script>
